import React from 'react';
import { Link } from 'gatsby';
import Img from 'gatsby-image';
import { get } from 'lodash-es';
import useAuthorPlaceholderImage from '../../graphql/staticQueries/useAuthorPlaceholderImage';
import { getAuthorsFromPost } from '../../helpers/contentFilter';
import { getPrimaryTag } from '../../helpers/util';

const BlogPostCard = ({ post, big, longPhoto }) => {
  const defaultImg = useAuthorPlaceholderImage().fixed;
  const authors = getAuthorsFromPost(post);
  const primaryTag = getPrimaryTag(post.frontmatter.tags).toUpperCase();
  return (
    <div className={`item ${big && 'big'} blog-post-card`} key={post.id}>
      <Link
        to={post.fields.url}
        className={`${big && 'big'} ${longPhoto &&
          'long-photo'} blog-post-card__img-container`}
      >
        <Img
          fluid={post.frontmatter.image.childImageSharp.fluid}
          alt={post.frontmatter.title}
          title={post.frontmatter.title}
        />
      </Link>
      <div
        className={`${big && 'big'} ${longPhoto &&
          'long-photo'} blog-post-card__content`}
      >
        <div className="category">{primaryTag}</div>
        <h2 className="title">
          <Link to={post.fields.url}>{post.frontmatter.title}</Link>
        </h2>
        <div className="excerpt">{post.excerpt}</div>
      </div>
      <div className="blog-post-card__footer">
        <div className="profile-img-container">
          <div className="author">
            {authors.map((author, idx) => {
              const authorImage = get(
                author,
                'frontmatter.profileImageFixed.childImageSharp.fixed',
                defaultImg
              );
              const className = `face-img-container ${
                idx === 0 ? '' : 'face-img-container--secondary'
              }`;
              const zIndex = authors.length - idx;
              const left = `${idx * 30}px`;
              return (
                <div
                  className={className}
                  style={{ zIndex, left }}
                  key={author.fields.url}
                >
                  <Img
                    className="profile-img"
                    fixed={authorImage}
                    alt={author.frontmatter.fullName}
                    title={author.frontmatter.fullName}
                  />
                </div>
              );
            })}
          </div>
        </div>
        <div className="read">
          <span>{post.timeToRead} min read</span>
        </div>
      </div>
    </div>
  );
};

export default BlogPostCard;

BlogPostCard.defaultProps = {
  big: false,
  longPhoto: false
};
